module.exports = __webpack_public_path__ + "img/Cloud-background.dfde9042.png";